import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20digital%20content%20library%20with%20floating%20cards%20and%20soft%20abstract%20geometric%20shapes%2C%20elegant%20modern%20Chinese%20aesthetic%20with%20calligraphy%20elements%2C%20warm%20amber%20and%20cream%20tones%2C%20clean%20minimalist%20design%2C%20organized%20grid%20layout%20with%20subtle%20gradients%2C%20atmospheric%20soft%20lighting&width=1600&height=900&seq=hero-bg-home&orientation=landscape"
        alt="国产一区精选内容聚合平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 leading-tight">
            国产一区精选内容聚合平台
          </h1>
          <p className="text-base md:text-lg text-background-100/90 mb-8 leading-relaxed max-w-2xl mx-auto">
            汇聚海量优质国产原创内容，精心分类整理，为您提供流畅、清晰、丰富的一站式浏览体验。无论您寻找热门资源还是冷门珍藏，国产一区都能满足您的需求。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/remen-tuijian"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              立即探索精选
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-2 text-background-50/60 text-xs">
          <span>向下滚动</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}